


document.addEventListener('DOMContentLoaded', () => {
  const videos = Array.from(document.querySelectorAll('.social-media-videos__video'));
  if (!videos.length) return;

  const isMobile = window.innerWidth <= 768;
  let current = 0;

  if (isMobile) {
    // === Mobile
    videos.forEach(video => {
      video.loop = true;
      video.muted = true;
      video.playsInline = true;
      video.setAttribute('preload', 'metadata');
      video.play().catch(() => {});
    });
  } else {
    // === DESKTOP
    function pauseOthers(activeIndex) {
      videos.forEach((v, i) => {
        if (i !== activeIndex) {
          v.pause();
          v.currentTime = 0;
          v.muted = true; 
        }
      });
    }

    function playVideo(index) {
      const video = videos[index];
      if (!video) return;

      current = index;
      pauseOthers(index);

      video.muted = true; 
      const playPromise = video.play();
      if (playPromise) playPromise.catch(() => {});
    }

    function playNext() {
      const nextIndex = (current + 1) % videos.length;
      playVideo(nextIndex);
    }

    videos.forEach((video, index) => {
      video.setAttribute('preload', 'metadata');
      video.muted = true;
      video.playsInline = true;

      
      video.addEventListener('ended', playNext);

      
      video.addEventListener('click', () => {
        playVideo(index);
      });
    });

    
    playVideo(0);
  }
});

